module.exports = __webpack_public_path__ + "img/12.cd5b3de6.jpg";